module.exports = __webpack_public_path__ + "img/photo2_9.8843b1f6.jpg";